import * as React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

export function withRouter(Component: any) {
	return function ComponentWithRouterProp(props: any) {
		let params = useParams();
		let navigate = useNavigate();
		let location = useLocation();

		return (
			<Component
				{...props}
				match={{ params }}
				history={{ push: navigate }}
				location={location}
			/>
		);
	}
}
